import React from 'react'
import { Box, Link } from '@mui/material'
import { __t } from '../../../../i18n/t'
import type { FieldError } from '../model'
import { Callout } from '../ui/basics'
import { focusField } from '../ui/focus'
import { CALLOUT } from '../ui/tokens'

const linkSx = {
  color: `${CALLOUT.errorText} !important`, textAlign: 'left', font: 'inherit', display: 'inline-flex', alignItems: 'center', minHeight: 40,
  '&:hover': { color: CALLOUT.errorText },
} as const

/** Resumo de erros no topo da etapa: cada item leva o foco até o campo (botão, não âncora: o app usa HashRouter). */
export const ErrorSummary: React.FC<{ errors: FieldError[] }> = ({ errors }) => (
  <Callout tone="error" role="alert" id="erros" tabIndex={-1}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, alignItems: 'flex-start' }}>
      <b>{errors.length === 1 ? __t('Falta resolver 1 item para continuar:') : __t('Falta resolver %{n} itens para continuar:', { n: errors.length })}</b>
      {errors.map(e => (
        <Link key={e.id} component="button" type="button" onClick={() => focusField(e.id)} underline="always" sx={linkSx}>
          {e.msg}
        </Link>
      ))}
    </Box>
  </Callout>
)
